export default __webpack_public_path__ + "static/media/loginBackgroung.7f41fa30.svg";